module.exports = __webpack_public_path__ + "img/Out-Patient Care.ca6e2203.png";